import { render } from "./linkExpired.vue?vue&type=template&id=04a817d2&scoped=true"
import script from "./linkExpired.vue?vue&type=script&lang=js"
export * from "./linkExpired.vue?vue&type=script&lang=js"

import "./linkExpired.vue?vue&type=style&index=0&id=04a817d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a817d2"]])

export default __exports__